/* eslint-disable @stylistic/max-len */
import { Collapsible, IosArrowDown } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { ACCORDION_ENDHANCER_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Accordion: Component = ({
  title,
  defaultIsOpen,
  childrenClassName,
  suffixText,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(defaultIsOpen ?? false);

  const summary = useMemo(() => (
    <div className={styles.containerSummary}>
      <span className={styles.textTitle}>
        {title}
      </span>
      <div className={styles.containerSuffix}>
        <span className={styles.textSuffix}>
          {suffixText}
        </span>
        <IosArrowDown
          className={cx(
            styles.icon,
            isOpen && styles.isOpen,
          )}
          size={ACCORDION_ENDHANCER_ICON_SIZE} />
      </div>
    </div>
  ), [suffixText, title, isOpen]);

  const handleChange = (open: boolean) => {
    setIsOpen(open);
  };

  useEffect(() => {
    if (isOpen) {
      containerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, [isOpen]);

  return (
    <div ref={containerRef}>
      <Collapsible
        className={childrenClassName}
        isContentOverflowVisible={isOpen}
        isOpen={isOpen}
        summary={summary}
        onChange={handleChange}>
        {children}
      </Collapsible>
    </div>
  );
};
